import { DataTableSkeleton } from '@Components/General/Skeletons'
import { createFileRoute } from '@tanstack/react-router'
import { donationsQueryOptions } from '@utils/queryOptions'
import ContactDonations from '@Views/Contacts/Contacts/ContactDetails/ContactDonations'

export const Route = createFileRoute('/contacts/$contactId_/donations')({
  component: ContactDonations,
  loader: (opts) =>
    opts.context.queryClient.ensureQueryData(donationsQueryOptions(opts.deps)),
  loaderDeps: ({ search }) => search,
  pendingComponent: DataTableSkeleton,
})
